import { render, staticRenderFns } from "./WarehouseData.vue?vue&type=template&id=468dcf44&"
import script from "./WarehouseData.vue?vue&type=script&lang=js&"
export * from "./WarehouseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports